<template lang="pug">
  .layout
    y-dialog(v-if="showModal" v-model='showModal' scrollable max-width='600px' persistent)
      v-card
        v-card-title.px-4
          v-layout
            div.h6.basic800--text {{ $t('images') }}
            v-spacer
            v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddImageDialog = !showAddImageDialog")
              v-icon.mr-1(small) mdi-plus
              | {{ $t('add_photo') }}

        v-divider.basic300
        v-card-text.px-4.pb-0
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            .items-layout.pt-4
              v-row(no-gutters)
                v-col(cols="4" style="padding: 1px")
                  v-card.pa-1(flat tile :color="mainImageSelected ? 'info400' : ''" @click="clickMainImage")
                    v-img(:src="mainImageFileUrl" aspect-ratio="1")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                template(v-for='(image, idx) in images')
                  v-col(cols="4" style="padding: 1px")
                    v-card.pa-1(flat tile :color="image.selected ? 'info400' : ''" @click="clickImages(idx)")
                      v-img(:src="image.id ? image.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
                        template(v-slot:placeholder)
                          v-row(class="fill-height ma-0" align="center" justify="center")
                            v-progress-circular(indeterminate color="grey")
                    //- product-image-item(:productId="productId" :image="image" :key="image.id" @deleted="handleDeleteItem")
          y-pagination.my-4(v-model="page" :pageSize="fetchCount" :count="count")
          
        v-card-actions
          v-spacer
          template(v-if="mainImageSelected")
            div.file-layout
              v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                | {{ $t('change_image') }}
              input.input-layout(type="file" @change="onMainFileChange" accept="image/*" style="width: 120px !important")
          template(v-else-if="images.filter(f => f.selected === true).length > 0")
            v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="danger500" text small @click="openDeleteDialog = true")
              eva-icon.mr-2(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="12" width="12" style="margin-top: 1px")
              | {{ $t('delete_selected') }}
          v-btn.ma-0(color='white', text @click='showModal = false')
            .button-Aa-small.info500--text {{ $t('close') }}
    
    .modals
      add-new-image(v-if="showAddImageDialog" :open.sync="showAddImageDialog" :productId="productId" @added="handleAddItem")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_image') }}
          v-card-text.p2.primary500--text.px-4
            div(v-if="images.filter(f => f.selected === true).length > 1") {{ $t('delete_images_confirmation') }}
            div(v-else) {{ $t('delete_image_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import ProductImageItem from '@/components/ProductImageItem.vue'
import AddNewImage from '@/components/dialogs/AddNewImage.vue'
import { resizeImage } from '@/utils'

export default {
  name: 'ManageProductImagesDialog',
  props: ['open', 'productId', 'mainImage'],
  components: { ProductImageItem, AddNewImage },
  data: () => ({
    isLoading: false,
    isFetching: false,
    fetchCount: 11,
    page: 1,
    // totalPage: 1,
    count: 0,
    images: [],
    showAddImageDialog: false,
    openDeleteDialog: false,
    mainImageSelected: false,
    mainImageFileUrl: '',
    mainImageFile: null,
    deleteList: [],
    doneDelete: []
  }),
  mounted () {
    this.fetchImages(1)
    this.mainImageFileUrl = this.mainImage
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchImages(val)
      }
    },
    mainImageFile: {
      deep: true,
      handler (val) {
        this.$emit('updateImage', [this.mainImageFileUrl, val])
      }
    },
    doneDelete (val) {
      if (val.length > 0 && val.length === this.deleteList.length) {
        this.isLoading = false
        this.openDeleteDialog = false
        setTimeout(() => {
          this.clearDelete()
        }, 1000)
      }
    }
  },
  methods: {
    fetchImages(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/${this.productId}/images/?page=${page}&page_size=${this.fetchCount}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.images = response.data.results.map(m => { return { ...m, selected: false}})
        this.count = response.data.count
        // const totalCount = response.data.count
        // if (totalCount % this.fetchCount == 0) {
        //   this.totalPage = totalCount/this.fetchCount
        // } else {
        //   this.totalPage = totalCount/this.fetchCount + 1
        // }
        // this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    // handleDeleteItem (item) {
    //   this.images = this.images.filter((x) => x !== item)
    // },
    handleAddItem (item) {
      this.images.push(item)
      this.$emit('activated')
    },
    startDelete () {
      this.isLoading = true
      this.deleteList = this.images.filter(f => f.selected === true)
      this.deleteList.forEach(o => {
        this.axios.delete(`/products/${this.productId}/images/${o.id}`)
          .then(() => {
            // this.$emit('deleted', this.image)
            this.images = this.images.filter(f => f.id !== o.id)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.doneDelete.push('o.id')
          })
      })
        
    },
    clearDelete () {
      this.deleteList = [],
      this.doneDelete = []
    },
    clickMainImage () {
      this.images = this.images.map(m => { return { ...m, selected: false}})
      this.mainImageSelected = true
    },
    clickImages (val) {
      this.mainImageSelected = false
      this.$set(this.images[val], 'selected', !this.images[val].selected)
    },
    async onMainFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.mainImageFileUrl = resizedImage.dataURL
      this.mainImageFile = resizedImage.file
    },
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>

<i18n>
{
  "en": {
    "delete_images_confirmation": "Are you sure you want to delete these images? These images will be deleted permanently."
  },
  "ms": {
  },
  "id": {
     "delete_images_confirmation": "Anda yakin ingin menghapus gambar ini? Gambar-gambar ini akan dihapus secara permanen."
  }
}
</i18n>
